module.exports = __webpack_public_path__ + "img/197.12f54dbb.jpg";